import { Injectable } from '@angular/core';
import {
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivate,
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { TokenStorageService } from '../services/token.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthService,
        private tokenService: TokenStorageService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        if (this.authService.isAuthenticated()) {
            const functionCode = route.data['functionCode'] as string;
            const permissions = JSON.parse(this.tokenService.getPermission());
            if (
                permissions &&
                permissions.filter((x) => x === functionCode).length > 0
            ) {
                return true;
            } else {
                this.router.navigate(['/auth/access'], {
                    queryParams: { redirect: state.url },
                });
                return false;
            }
        }

        this.router.navigate(['/login'], {
            queryParams: { redirect: state.url },
            replaceUrl: true,
        });
        return false;
    }
}
